<div class="range-slider-container" *ngIf="rangeConfig">
  <!-- D4: stop touch propagation so scroll container cannot steal the drag gesture -->
  <div (touchstart)="$event.stopPropagation()">
    <ion-range
      [min]="rangeConfig.min"
      [max]="rangeConfig.max"
      [step]="rangeConfig.step"
      [pin]="true"
      [dualKnobs]="true"
      [pinFormatter]="formatPin"
      [(ngModel)]="rangeValue"
      (ionChange)="onSliderChange($event)">
    </ion-range>
  </div>

  <div class="range-ticks">
    <span *ngFor="let tick of tickValues" class="range-tick-label">
      {{tick}}{{rangeConfig?.unit ?? ''}}
    </span>
  </div>

  <div class="range-input-row" *ngIf="showInputs">
    <div class="range-input-cell">
      <p class="range-input-label">{{'RANGE_MIN' | translate}}</p>
      <ion-input
        type="number"
        [min]="rangeConfig.min"
        [max]="rangeConfig.max"
        [(ngModel)]="minInput"
        (ionInput)="onMinInput()"
        (ionBlur)="onMinBlur()">
      </ion-input>
    </div>
    <div class="range-input-cell">
      <p class="range-input-label">{{'RANGE_MAX' | translate}}</p>
      <ion-input
        type="number"
        [min]="rangeConfig.min"
        [max]="rangeConfig.max"
        [(ngModel)]="maxInput"
        (ionInput)="onMaxInput()"
        (ionBlur)="onMaxBlur()">
      </ion-input>
    </div>
  </div>
</div>
